import axios from "axios";
import { toast } from "react-toastify";
import { setLoggedIn, setUserDataAction, setAuthToken } from "../reducers/user";
// import { countries } from "../../components/authentication/RegistrationForm";
import { setFirstTimeRegistration } from "../reducers/ui";

const toastSetting = {
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "dark",
};

export const loginAsync = (code) => {
  return async (dispatch) => {
    const toastRef = toast.loading("Logging in");

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}/acc-chatbot/three-legged-access-token`,
        {
          code: code,
          redirect_uri: process.env.REACT_APP_REDIRECT_URL,
          sign_up: false,
        }
      );
      let data = response.data;
      if (data.success === true) {
        toast.update(toastRef, {
          render: `${data.message}`,
          type: "success",
          isLoading: false,
          ...toastSetting,
        });
        dispatch(setLoggedIn(true));
        dispatch(setUserDataAction(data.data));
        dispatch(setAuthToken(data.auth));
      } else {
        toast.update(toastRef, {
          render: `${data.message}`,
          type: "error",
          isLoading: false,
          ...toastSetting,
        });
      }
    } catch (err) {
      console.log(err);
      toast.update(toastRef, {
        render: `Something went wrong. Please try again later`,
        type: "error",
        isLoading: false,
        ...toastSetting,
      });
    }
  };
};

export const signUpAsync = (code, phone_number, country) => {
  return async (dispatch) => {
    const toastRef = toast.loading("Logging in");
    dispatch(setFirstTimeRegistration(false));
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}/acc-chatbot/three-legged-access-token`,
        {
          code: code,
          redirect_uri: process.env.REACT_APP_REDIRECT_URL,
          phone_number,
          country,
          sign_up: true,
        }
      );
      let data = response.data;
      if (data.success === true) {
        toast.update(toastRef, {
          render: `${data.message}`,
          type: "success",
          isLoading: false,
          ...toastSetting,
        });
        dispatch(setLoggedIn(true));
        dispatch(setUserDataAction(data.data));
        dispatch(setAuthToken(data.auth));
      } else {
        toast.update(toastRef, {
          render: `${data.message}`,
          type: "error",
          isLoading: false,
          ...toastSetting,
        });
      }
    } catch (err) {
      console.log(err);
      toast.update(toastRef, {
        render: `Something went wrong. Please try again later`,
        type: "error",
        isLoading: false,
        ...toastSetting,
      });
    }
  };
};

export const cancelSubscription = (email) => {
  return async (dispatch) => {
    const config = {
      method: "POST",
      url: `${process.env.REACT_APP_API_ENDPOINT}/subscription/subscription-cancel`,
      data: { email },
    };
    const toastRef = toast.loading("Cancelling Subscription");
    try {
      const response = await axios(config);
      let data = response.data;
      if (data.success === true) {
        toast.update(toastRef, {
          render: `${data.message}`,
          type: "success",
          isLoading: false,
          ...toastSetting,
        });
      } else {
        toast.update(toastRef, {
          render: `${data.message}`,
          type: "error",
          isLoading: false,
          ...toastSetting,
        });
      }
    } catch (err) {
      toast.update(toastRef, {
        render: `Something went wrong. Please try again later`,
        type: "error",
        isLoading: false,
        ...toastSetting,
      });
    }
  };
};

export const asyncUserDashboardData = (email, token) => {
  return async (dispatch) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT}/user/user-info`,
        {
          params: { email: email },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      let data = response.data;
      dispatch(setUserDataAction(data));
    } catch (err) {
      console.log(err);
    }
  };
};
